import React from 'react'
import { slugs } from '@/constants/slugs'
import {
  getProjectStyle,
  createHowPreOrdersWorkAnswer,
  createRefundPolicyAnswer,
  createContactSupportAnswer,
} from '../shared'
import { GiveawayFaq } from '../types'

export const getLastRodeoFaqs = (): GiveawayFaq[] => [
  {
    key: 'releaseDate',
    question: (t) => t('lastRodeoReleaseDateQuestion', 'When will the movie The Last Rodeo be in theaters?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.theLastRodeo)}>
        {t('lastRodeoReleaseDateAnswer', 'The Last Rodeo will open in theaters on May 23rd, 2025.')}
      </span>
    ),
  },
  {
    key: 'howPreOrdersWork',
    question: (t) => t('howPreOrdersWorkQuestion', 'How do pre-orders work?'),
    answer: createHowPreOrdersWorkAnswer(slugs.theLastRodeo, 'LastRodeo'),
  },
  {
    key: 'refundPolicy',
    question: (t) => t('refundPolicyQuestion', 'What is the refund policy?'),
    answer: createRefundPolicyAnswer(slugs.theLastRodeo, false),
  },
  {
    key: 'contactSupport',
    question: (t) => t('contactSupportQuestion', 'How do I contact support?'),
    answer: createContactSupportAnswer(slugs.theLastRodeo),
  },
]
